import API from 'utils/api';
import { DATE_FORMAT } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/documentos-para-tramites/';

/**
 * GET Documentos De Tramites
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Documento De Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDocumentoDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

const formatFileValues = (_values) => {
  if (_values.archivo) {
    const values = { ..._values };
    values.fecha_vencimiento = values.fecha_vencimiento?.format(DATE_FORMAT) || '';
    const formData = new FormData();
    const valuesKeys = Object.keys(values);
    valuesKeys.forEach((key) => {
      formData.append(`${key}`, values[key] || '');
    });
    formData.append('tamanio', (values.archivo.size / 1024 / 1024).toFixed(2));
    formData.append('extension_del_documento', values.archivo.name.split('.').pop().toLowerCase());

    const _config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return [formData, _config];
  }
  return [_values];
};

/**
 * POST Documento De Tramite
  * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const postDocumentoDeTramite = async (_values) => {
  try {
    const [values, config] = formatFileValues(_values);
    const response = await API.post(baseURI, values, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Documento De Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentoDeTramite = async (id, _values) => {
  try {
    const [values, config] = formatFileValues(_values);
    const response = await API.patch(`${baseURI}${id}`, values, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Documento De Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteDocumentoDeTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
